
// ReSharper disable InconsistentNaming
define('coach/cumulative/view/views/game-chooser-view',['require','jquery','backbone','_','backbone.marionette','moment','handlebars','hbs!../templates/game-chooser-dialog','events','actionclick','lib/kickoff/svg-replacer','selectize','services','string!format,pluralize'],function (require) {
    'use strict';

    var $ = require('jquery'),
        Backbone = require('backbone'),
        _ = require('_'),
        Marionette = require('backbone.marionette'),
        moment = require('moment'),
        handlebars = require('handlebars'),
        gameChooserDialogTemplate = require('hbs!../templates/game-chooser-dialog'),
        events = require('events'),
        actionclick = require('actionclick'),
        svgReplacer = require('lib/kickoff/svg-replacer'),
        selectize = require('selectize'),
        services = require('services'),
        string = require('string!format,pluralize');

    var GameChooserDialogView = Marionette.ItemView.extend({
        id: 'game-chooser-view',
        className: 'game-chooser-dialog',
        template: gameChooserDialogTemplate,
        events: {
            'actionclick .smooth-modal-close, .btn-cancel': '_closeClicked',
            'actionclick #update-season-filter': '_updateSeason',
            'actionclick .game': '_gameClicked'
        },
        ui: {
            cancelButton: '.actions .btn-cancel',
            submitButton: '.actions #update-season-filter'
        },
        modelEvents: {
            'change': '_modelChanged'
        },
        initialize: function (options) {
            var scheduleGames = options.model.get('scheduleGames');
            var selectedGameIds = options.model.get('selectedGameIds');
        },
        _updateSeason: function () {
            var unselectedGameIds = this.model.get('scheduleGames')
                .filter(function (g) {
                    return !g.isSelected;
                }).map(function (g) {
                    return g.teamGameDto.game.gameId;
                });
            
            var teamId = this.model.get('teamId');
            var seasonId = this.model.get('seasonId');

            var setFilterRequest = services('setSeasonFilter', { teamId: teamId, seasonId: seasonId });
            this.ui.submitButton.addClass('btn-loading');
            this.ui.cancelButton.addClass('disabled');
            this.ui.submitButton.addClass('disabled');
            
            setFilterRequest.post(unselectedGameIds).done(function (response) {
                window.location = response;
            });
        },
        _gameClicked: function (e) {
            var gameId = this.$(e.currentTarget).attr('data-game-id');
            var gameModel = _.find(this.model.get('scheduleGames'), function (g) {
                return g.teamGameDto.game.gameId == gameId;
            });
            if (gameModel.isDisabled) {
                return;
            }
            gameModel.isSelected = !gameModel.isSelected;

            this._refreshSelectedStatus(e.currentTarget);
        },
        _refreshSelectedStatus: function(gameElem) {
            var gameId = this.$(gameElem).attr('data-game-id');
            var gameModel = _.find(this.model.get('scheduleGames'), function (g) {
                return g.teamGameDto.game.gameId == gameId;
            });

            var selector = string.format('.game[data-game-id="{0}"]', gameId);
            
            var game = this.$el.find(selector);
            game.find('.check .selected').toggleClass('hidden', !gameModel.isSelected);
            game.find('.check .unselected').toggleClass('hidden', gameModel.isSelected);
        },
        _closeClicked: function () {
            this.model.trigger('closeDialog');
        },
        showing: false,
        _modelChanged: function () {
            this.render();
        },
        onRender: function () {
            this.$('img[src$=".svg"]').each(svgReplacer);
            var self = this;
            this.$('li.game').each(function (i, g) { self._refreshSelectedStatus(g); });
        },
        onShow: function (view) {
        }
    });

    return GameChooserDialogView;
});